export default {
  Title: 'Title',
  Options: 'Option',
  CheckList: 'CheckList'
}
